import {Component, ConfigOptions} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {apiClient} from 'common/util/api-client';
import {promisifyModal} from 'common/components/modal/utils';

import './dataset';
import css from './index.styl?inline';
import './dataset/index.styl';
import template from './index.jade';

export const DemoProjectListEndpoint = `/api/app/demo_project/list`;
export const DemoProjectJoinEndpoint = `/api/app/demo_project/join`;

export interface DemoProject {
  icon: string;
  description: string;
  projectId: number;
}

interface DemoSelectorState {
  demoProjects: DemoProject[];
  loadingProjects: boolean;
  selectedDemo: number;
  waitingOnResponse: boolean;
}
interface JoinDemoProjectResult {
  success: boolean;
  error: string;
  redirect_url: string;
}

export interface ListDemoProjectResult extends Omit<DemoProject, 'projectId'> {
  project_id: number;
}

export class DemoProjectSelector extends Component<DemoSelectorState> {
  static get attrsSchema() {
    return {};
  }

  get config(): ConfigOptions<DemoSelectorState> {
    return {
      css,
      useShadowDom: true,
      template,
      defaultState: {
        demoProjects: [],
        loadingProjects: true,
        selectedDemo: null,
        waitingOnResponse: false,
      },
      helpers: {
        clickedDataset: (projectId) => this.update({selectedDemo: projectId}),
        clickedExploreDemoButton: (): void => {
          this.update({waitingOnResponse: true});
          this.joinDemoProject().then(() => this.update({waitingOnResponse: false}));
        },
      },
    };
  }

  connectedCallback() {
    super.connectedCallback();
    this.listDemoProjects().then((demoProjects) => this.update({demoProjects, loadingProjects: false}));
  }
  async listDemoProjects(): Promise<DemoProject[]> {
    const demoProjects: DemoProject[] = [];
    const demoProjectsResult = await apiClient.get<ListDemoProjectResult[]>(DemoProjectListEndpoint);
    demoProjectsResult.forEach((project) =>
      demoProjects.push({projectId: project.project_id, ...project} as DemoProject),
    );
    return demoProjects;
  }
  async joinDemoProject() {
    try {
      const result = await apiClient.post<JoinDemoProjectResult>(DemoProjectJoinEndpoint, {
        project_id: this.state.selectedDemo,
      });
      window.location.assign(`/report/${this.state.selectedDemo}${result.redirect_url}`);
    } catch (err) {
      this.handleError(err.message);
    }
  }
  handleError(message: string): void {
    this.dispatchEvent(
      new CustomEvent(`error`, {
        detail: {
          message,
        },
      }),
    );
  }
}

export const DemoSelectorModal = defineAndMakeJsxFactory(`mp-demo-selector-modal`, DemoProjectSelector);

export const openDemoProjectSelectorModal = (onErrorMessage: (ev: CustomEvent) => void) => {
  return promisifyModal({
    tagName: `mp-demo-selector-modal`,
    attrs: {},
    closeEvents: [`error`],
    closeHandler: (ev) => {
      if (ev.type === `error`) {
        onErrorMessage(ev);
      }
    },
  });
};
